// The "first-time setup done" flag. It outlives a logout by design (a returning clinician must not be
// re-onboarded), so the signed-in clinician is part of the key: an org-only key let a second clinician
// on the same workstation inherit the first one's flag and skip the first-run unit step. Mirrors
// `timeBudgetKey` in ../time-mode/time-mode.storage.ts. Read and written from two surfaces (onboarding
// and the daily briefing), so the key lives here rather than in either of them.

const SETUP_DONE_KEY_PREFIX = 'pa_setup_done_'

/** `pa_setup_done_<userId>_<orgId>`; an unresolved identity uses the same sentinels as the budget key. */
function setupDoneKey(userId: string | null, orgId: string | null): string {
  return `${SETUP_DONE_KEY_PREFIX}${userId ?? 'anon'}_${orgId ?? 'none'}`
}

/** True when THIS clinician has already completed (or skipped) first-time setup in THIS org. */
export function isSetupDone(
  userId: string | null,
  orgId: string | null
): boolean {
  try {
    return localStorage.getItem(setupDoneKey(userId, orgId)) === '1'
  } catch {
    // Storage unavailable (private mode): read as not-done, so onboarding re-shows rather than a
    // clinician silently losing the step.
    return false
  }
}

/** Record that THIS clinician has completed (or skipped) first-time setup in THIS org. */
export function markSetupDone(
  userId: string | null,
  orgId: string | null
): void {
  try {
    localStorage.setItem(setupDoneKey(userId, orgId), '1')
  } catch {
    // localStorage unavailable (private mode): onboarding re-shows next load, an acceptable degrade.
  }
}
